import { useRootStore } from '@hooks/useRootStore';
import ShoppingCartTwoToneIcon from '@mui/icons-material/ShoppingCartTwoTone';
import { Badge, IconButton } from '@mui/material';
import { grey } from '@mui/material/colors';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface OrderCartIconProps {
}

const OrderCartIcon: React.FC<OrderCartIconProps> = observer(({ }) => {
    const { orderEditViewStore } = useRootStore();
    const { setIsOrderCartDrawerOpen, orderFoods, isOrderEmpty } = orderEditViewStore;

    return (
        <IconButton
            onClick={() => setIsOrderCartDrawerOpen(true)}
            color="secondary"
            sx={{
                mr: 1,
                display: { md: "none" },
                bgcolor: grey[200],
                ":focus": {
                    bgcolor: grey[200]
                }
            }}>
            <Badge badgeContent={isOrderEmpty ? null : orderFoods.length} color="primary">
                <ShoppingCartTwoToneIcon />
            </Badge>
        </IconButton>
    )
})

export default OrderCartIcon;